import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const useFetchHealthMailLoginDetails = () => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const fetchHealthMailLoginDetails = async () => {
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.get(`${tenant}/healthmailcredentials`);

    return response.data;
  };

  return useQuery({
    queryKey: ["healthMailLoginDetails", tenant],
    queryFn: fetchHealthMailLoginDetails,
    enabled: !!tenant,
    meta: { skipGlobalError: true },
    refetchInterval: 10000,
    refetchOnWindowFocus: true,
  });
};

export { useFetchHealthMailLoginDetails };